<template>
  <section id="articles">
    <Header :class="{header: true, hidden: hideHeader}"
      v-on:login="$emit('login')" :scrolled="true"/>
    <div class="loading" v-if="loading"></div>
    <div class="notFound" v-else-if="!d">Not Found</div>
    <div v-else>
      <div :class="{tabMenu: true, hidden: hideHeader}">
        <div class="tabMenuWrapper">
          <router-link to="/" class="tabMenuItem z">Home</router-link>
          <div class="tabMenuItem x">/</div>
          <div v-on:click="$router.back()" class="tabMenuItem z">
            Pesan dan Kreasi</div>
          <div class="tabMenuItem x">/</div>
          <div class="tabMenuItem y">{{d.title}}</div>
        </div>
      </div>
      <div class="sectionCnt">
        <div class="videoCntVp">
          <VuePlyr ref="video">
            <video></video>
          </VuePlyr>
        </div>
        <div class="sectionHeader">
          <h2>{{d.title}}</h2>
          <div class="creator">Kreator: {{d.author.name}}</div>
        </div>
      </div>
    </div>
    <LoadingDialog ref="loadingDialog"/>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import VuePlyr from 'vue-plyr';
import Header from '@/components/Header.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';

export default {
  name: 'home',
  components: { Header, LoadingDialog, VuePlyr },
  data() {
    return {
      loading: true,
      hideHeader: false,
      tabActive: 'article',
      d: null,
    };
  },
  computed: {
    video() {
      return this.$refs.video.player;
    },
  },
  methods: {
    ...mapActions([
      'chMenuActive',
    ]),
    selectTab(tab) {
      this.tabActive = tab;
      this.$refs.loadingDialog.open();
      this.getData();
    },
    submitPesan() {
      // if (!this.$session.get('jwt')) {
      //   this.$emit('login');
      //   return;
      // }
      this.$router.push('/bicara-bumi/pesan-dan-kreasi/submit');
    },
    getData() {
      this.loading = true;
      this.$http.get(this.$config.uri(`article/user/detail/${this.page}`)).then((r) => {
        this.d = (r.data.status === 200) ? r.data.data : null;
        this.loading = false;
        setTimeout(() => {
          this.playVideo();
        });
      });
    },
    playVideo() {
      const sources = [];
      if (this.d.video.vid1080p) {
        sources.push({
          src: this.d.video.vid1080p,
          type: 'video/mp4',
          size: 1080,
        });
      }
      if (this.d.video.vid720p) {
        sources.push({
          src: this.d.video.vid720p,
          type: 'video/mp4',
          size: 720,
        });
      }
      if (this.d.video.vid480p) {
        sources.push({
          src: this.d.video.vid480p,
          type: 'video/mp4',
          size: 480,
        });
      }
      if (this.d.video.vid360p) {
        sources.push({
          src: this.d.video.vid360p,
          type: 'video/mp4',
          size: 360,
        });
      }
      this.video.source = {
        type: 'video',
        title: this.d.title,
        sources,
      };
      this.video.play();
    },
  },
  mounted() {
    this.page = this.$route.params.slug;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Pesan dan Kreasi - Bumi Butuh Aksi';
    this.chMenuActive('bicara-bumi');
    this.getData();
  },
};
</script>

<style scoped lang="scss">
#articles{
  min-height: 100vh;
  background-color: #f4f6f1;
  box-sizing: border-box;
  padding-top: 80px;
}

.sectionCnt{
  max-width: 960px;
  margin: 0 auto;
  @media (max-width: 1300px) {
    max-width: none;
    margin: 0 20px;
  }
}

.sectionHeader{
  border-top: #999 2px solid;
  position: relative;
  padding: 10px 0 60px;
  margin-top: 20px;
  h2{
    font-size: 42px;
    font-weight: 800;
    margin: 0;
    @media (max-width: 680px) {
      font-size: 26px;
    }
  }
  .searchCnt{
    position: absolute;
    right: 0; top: 80px;
    input{
      border: none;
      background-color: #fff;
      font-size: 16px;
      padding: 10px 20px;
      line-height: 1;
      border-radius: 50px;
      border: #ddd 1px solid;
      width: 300px;
    }
    button{
      position: absolute;
      border: none;
      background-color: #fff;
      width: 30px; height: 30px;
      right: 10px; top: 4px;
      background-image: url(../assets/loupe.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .6;
    }
  }
}

.videoCntVp{
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 80px auto 0;
  min-height: 400px;
  @media (max-width: 680px) {
    min-height: 200px;
  }
}

.loading{
  position: absolute;
  top: 80px; left: 0; right: 0; bottom: 0;
  background-image: url(../assets/loading.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
}

.tabMenu{
  position: fixed;
  top: 80px;
  left: 0;
  background-color: #f5f5f5;
  right: 0;
  border-bottom: #eee 1px solid;
  transition: all .3s ease;
  z-index: 9;
  @media (max-width: 760px) {
    top: 63px;
  }
  &.hidden{
    top: 0;
  }
  .tabMenuWrapper{
    display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 0 10px;
    .tabMenuItem{
      padding: 10px 20px 8px;
      color: #444;
      cursor: pointer;
      font-weight: 600;
      border-bottom: transparent 3px solid;
      margin-bottom: -1px;
      text-decoration: none;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      @media (max-width: 760px) {
        padding-left: 10px;
        padding-right: 10px;
      }
      &.z{
        color: #084630;
        &:hover{
          color: #31c1f4;
        }
      }
      &.x{
        padding-left: 0;
        padding-right: 0;
        color: #aaa;
      }
      &.y{
        color: #767676;
        font-weight: normal;
        @media (max-width: 760px) {
          max-width: 160px;
        }
      }
    }
  }
}

</style>
